import { registerModule } from '@xsyx/easy-api-h5'
import modles from './bankInfo';

export const bankInfoService = registerModule('', modles)